"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptySpecialCoverageCatalog = void 0;
function makeEmptySpecialCoverageCatalog() {
    return {
        code: '',
        label: '',
        content: '',
    };
}
exports.makeEmptySpecialCoverageCatalog = makeEmptySpecialCoverageCatalog;
//# sourceMappingURL=SpecialCoverageCatalog.js.map